import React, { useState } from 'react';
import {
  BookOpen,
  FileText,
  Presentation,
  Search,
  ExternalLink,
  Database,
  Phone,
  Mail,
  Calendar,
  Sparkles,
  FileSignature,
  Settings,
  Library,
  Users,
  Briefcase,
  BarChart3,
  Code,
  Palette,
  Building,
  FolderOpen,
  Key,
  HardDrive,
} from 'lucide-react';
import SectionHeader from '../ui/SectionHeader';

const wikiSections = [
  { icon: BookOpen, title: 'Guía General', desc: 'Introducción a Sonneil Help' },
  { icon: Users, title: 'RR.HH.', desc: 'On Boarding y formación' },
  { icon: Mail, title: 'Marketing', desc: 'Email marketing y leads' },
  { icon: Briefcase, title: 'Comercial', desc: 'Formación comercial' },
  { icon: Database, title: 'Salesforce', desc: 'Manuales de SF' },
  { icon: Building, title: 'Partners', desc: 'App de Sonneil Partners' },
  { icon: BarChart3, title: 'Data', desc: 'Análisis de datos' },
  { icon: Code, title: 'Tech Base', desc: 'Documentación técnica' },
  { icon: Palette, title: 'Diseño', desc: 'Guías y recursos' },
];

const manuals = {
  'crm-ventas': [
    {
      id: 'manual-sf',
      title: 'Manual Uso de SF Sales Agents',
      description: 'Guía completa para agentes de ventas en Salesforce',
      icon: Database,
      url: 'https://drive.google.com/file/d/1W93QNyOx83v5otMYovYuUk4cQeYT1SzA/view?usp=drive_link',
      type: 'pdf',
    },
    {
      id: 'manual-aircall',
      title: 'Manual de Configuración Aircall',
      description: 'Configuración y uso de la plataforma de llamadas',
      icon: Phone,
      url: 'https://drive.google.com/file/d/1-Tk6qQ5IL9quvCmPVLLD2B6L4obBV0FC/view?usp=drive_link',
      type: 'pdf',
    },
  ],
  'google-workspace': [
    {
      id: 'funciones-workspace',
      title: 'Funciones Workspace',
      description: 'Guía de administración de Google Workspace',
      icon: Settings,
      url: 'https://drive.google.com/file/d/1gRKOYHc0XCdKz_Hceq3Iad8utsPDSAuZ/view?usp=drive_link',
      type: 'pdf',
    },
    {
      id: 'manual-gmail',
      title: 'Manual Configuración Gmail',
      description: 'Optimización y organización del correo',
      icon: Mail,
      url: 'https://drive.google.com/file/d/1jp3ecLfQvu32SOmeHCGqqr9cuE3GGCY0/view?usp=drive_link',
      type: 'pdf',
    },
    {
      id: 'manual-calendar',
      title: 'Manual Google Calendar',
      description: 'Gestión eficiente de tiempo y citas',
      icon: Calendar,
      url: 'https://drive.google.com/file/d/1f873kqq0PaHuKst7451_DAEpgDsymBJM/view?usp=drive_link',
      type: 'pdf',
    },
    {
      id: 'manual-firma',
      title: 'Manual de Firma Corporativa',
      description: 'Creación de firma de email profesional',
      icon: FileSignature,
      url: 'https://drive.google.com/file/d/1mEWT1UUwvU1RRVjPlG9gbHRMZmUti9dY/view?usp=drive_link',
      type: 'pdf',
    },
    {
      id: 'manual-firma-workspace',
      title: 'Manual Uso de Firma Google Workspace',
      description: 'Configuración de firmas en Google Workspace',
      icon: FileSignature,
      url: 'https://drive.google.com/file/d/1xEjHQBvuSUk74z5lxVMTF5q8rt7YDLxP/view?usp=drive_link',
      type: 'pdf',
    },
    {
      id: 'manual-gemini',
      title: 'Manual Funciones Gemini IA',
      description: 'Uso de inteligencia artificial en Google',
      icon: Sparkles,
      url: 'https://drive.google.com/file/d/1h7Gw2kePKpfgWusdMeVInyTQ8nZNDSA4/view?usp=drive_link',
      type: 'pdf',
    },
    {
      id: 'manual-drive-permisos',
      title: 'Manual Permisos de Acceso y Gestión Temporal en Google Drive',
      description: 'Control de accesos y permisos en Drive',
      icon: FolderOpen,
      url: 'https://drive.google.com/file/d/1yKXM49qWHawigONW7TBFxlQVooRy8823/view?usp=drive_link',
      type: 'pdf',
    },
  ],
  'seguridad-ti': [
    {
      id: 'manual-passwd',
      title: 'Manual Uso de Passwd',
      description: 'Gestor de contraseñas corporativo',
      icon: Key,
      url: 'https://drive.google.com/file/d/19Z-dYj99i4YezaT43xmPX3e7mUByV-14/view?usp=drive_link',
      type: 'pdf',
    },
    {
      id: 'manual-pulseway',
      title: 'Manual de Funcionamiento de Pulseway en Sonneil SL',
      description: 'Sistema de monitorización y gestión remota',
      icon: HardDrive,
      url: 'https://drive.google.com/file/d/16X9UojxxAegPbwkjTeZnPFDg5VWWV10r/view?usp=drive_link',
      type: 'pdf',
    },
  ],
};

const trainings = [
  {
    id: 'capacitacion-aircall',
    title: 'Capacitación Herramienta de llamadas Aircall',
    description: 'Presentación completa sobre el uso de Aircall',
    duration: '45 min',
    type: 'presentation',
    url: 'https://docs.google.com/presentation/d/e/2PACX-1vRF1pZ__zECYtjEqp1DnG3zIX8ioKiFNYduPWyoHW_2yGbSVAU7KKpex6P9LS70Dbi2xp-Frcqe2o5A/pubembed?start=false&loop=false&delayms=3000',
    embedUrl: 'https://docs.google.com/presentation/d/e/2PACX-1vRF1pZ__zECYtjEqp1DnG3zIX8ioKiFNYduPWyoHW_2yGbSVAU7KKpex6P9LS70Dbi2xp-Frcqe2o5A/pubembed?start=false&loop=false&delayms=3000',
  },
];

const TrainingPage = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [activeCategory, setActiveCategory] = useState('all');
  const [showEmbed, setShowEmbed] = useState(null);

  const categories = [
    { id: 'all', label: 'Todos' },
    { id: 'crm-ventas', label: 'CRM y Ventas' },
    { id: 'google-workspace', label: 'Google Workspace' },
    { id: 'seguridad-ti', label: 'Seguridad e IT' },
  ];

  const allManuals = Object.values(manuals).flat();
  
  const filteredManuals = allManuals.filter((manual) => {
    const matchesSearch = manual.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
                         manual.description.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesCategory = activeCategory === 'all' || 
                           Object.entries(manuals).find(([cat, items]) => 
                             items.includes(manual) && cat === activeCategory
                           );
    return matchesSearch && (activeCategory === 'all' || matchesCategory);
  });

  return (
    <div className="animate-stagger">
      {/* Header */}
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-text-primary mb-2">Formación y Documentación</h1>
        <p className="text-text-secondary">
          Biblioteca de manuales, presentaciones y recursos formativos
        </p>
      </div>

      {/* Wiki Featured Section */}
      <section id="sonneil-wiki" className="section scroll-mt-24">
        <div className="card overflow-hidden border-2 border-warning/30">
          <div className="bg-gradient-to-r from-orange-500 to-amber-500 p-6 text-white">
            <div className="flex items-center gap-4">
              <div className="w-16 h-16 bg-white/20 rounded-xl flex items-center justify-center">
                <Library size={32} />
              </div>
              <div className="flex-1">
                <h2 className="text-2xl font-bold">Sonneil Wiki</h2>
                <p className="text-white/80">Nuestra base de conocimiento más completa</p>
              </div>
              <a
                href="https://help.sonneil.com"
                target="_blank"
                rel="noopener noreferrer"
                className="hidden md:flex items-center gap-2 bg-white text-orange-600 px-6 py-3 rounded-lg font-semibold hover:bg-orange-50 transition-colors"
              >
                Acceder a la Wiki
                <ExternalLink size={18} />
              </a>
            </div>
          </div>
          
          <div className="p-6">
            <p className="text-text-secondary mb-6">
              En nuestra Wiki encontrarás toda la documentación organizada por departamentos: 
              guías, manuales, procedimientos y recursos de formación.
            </p>

            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 mb-6">
              {wikiSections.map((section, index) => {
                const Icon = section.icon;
                return (
                  <div key={index} className="bg-background rounded-lg p-3 text-center">
                    <Icon size={20} className="mx-auto text-warning mb-2" />
                    <p className="text-sm font-medium text-text-primary">{section.title}</p>
                    <p className="text-xs text-text-tertiary">{section.desc}</p>
                  </div>
                );
              })}
            </div>

            <a
              href="https://help.sonneil.com"
              target="_blank"
              rel="noopener noreferrer"
              className="md:hidden btn-primary w-full justify-center"
            >
              Acceder a la Wiki
              <ExternalLink size={18} />
            </a>
          </div>
        </div>
      </section>

      {/* Search and Filter */}
      <div className="card p-4 mb-8">
        <div className="flex flex-col md:flex-row gap-4">
          <div className="relative flex-1">
            <Search size={18} className="absolute left-4 top-1/2 -translate-y-1/2 text-text-tertiary" />
            <input
              type="text"
              placeholder="Buscar manuales y documentación..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="input pl-11"
            />
          </div>
          <div className="flex gap-2">
            {categories.map((cat) => (
              <button
                key={cat.id}
                onClick={() => setActiveCategory(cat.id)}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                  activeCategory === cat.id
                    ? 'bg-primary text-white'
                    : 'bg-background text-text-secondary hover:text-primary'
                }`}
              >
                {cat.label}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Manuals by Category */}
      {Object.entries(manuals).map(([categoryId, categoryManuals]) => {
        if (activeCategory !== 'all' && activeCategory !== categoryId) return null;
        
        const categoryNames = {
          'crm-ventas': 'CRM y Ventas',
          'google-workspace': 'Google Workspace',
          'seguridad-ti': 'Seguridad e IT',
        };

        const filtered = categoryManuals.filter((manual) =>
          manual.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
          manual.description.toLowerCase().includes(searchQuery.toLowerCase())
        );

        if (filtered.length === 0) return null;

        return (
          <section key={categoryId} className="section">
            <SectionHeader title={categoryNames[categoryId]} />
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {filtered.map((manual) => {
                const Icon = manual.icon;
                return (
                  <div id={manual.id} key={manual.id} className="card p-5 hover:border-primary/30 border border-transparent transition-all scroll-mt-24">
                    <div className="flex items-start gap-4">
                      <div className="w-12 h-12 rounded-xl bg-primary-lighter/50 flex items-center justify-center flex-shrink-0">
                        <Icon size={24} className="text-primary" />
                      </div>
                      <div className="flex-1 min-w-0">
                        <h4 className="font-medium text-text-primary line-clamp-2">{manual.title}</h4>
                        <p className="text-sm text-text-tertiary mt-1 line-clamp-2">{manual.description}</p>
                        <div className="flex items-center gap-3 mt-3">
                          <span className="badge bg-primary-lighter/50 text-primary-dark">
                            <FileText size={12} className="mr-1" />
                            PDF
                          </span>
                          <a
                            href={manual.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-primary text-sm hover:underline flex items-center gap-1"
                          >
                            Ver Manual
                            <ExternalLink size={14} />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </section>
        );
      })}

      {/* Training Presentations */}
      <section className="section">
        <SectionHeader
          title="Presentaciones de Capacitación"
          description="Material de formación interactivo"
        />
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {trainings.map((training) => (
            <div id={training.id} key={training.id} className="card overflow-hidden scroll-mt-24">
              <div className="bg-gradient-to-r from-primary to-primary-dark p-5 text-white">
                <div className="flex items-center gap-3">
                  <Presentation size={24} />
                  <div>
                    <h4 className="font-semibold">{training.title}</h4>
                    <p className="text-sm text-white/70">{training.duration}</p>
                  </div>
                </div>
              </div>
              
              {showEmbed === training.id && (
                <div className="aspect-video bg-gray-100">
                  <iframe
                    src={training.embedUrl}
                    frameBorder="0"
                    className="w-full h-full"
                    allowFullScreen
                    title={training.title}
                  />
                </div>
              )}
              
              <div className="p-4">
                <p className="text-text-secondary text-sm mb-4">{training.description}</p>
                <div className="flex gap-3">
                  <button
                    onClick={() => setShowEmbed(showEmbed === training.id ? null : training.id)}
                    className="btn-secondary btn-sm"
                  >
                    {showEmbed === training.id ? 'Ocultar' : 'Ver aquí'}
                  </button>
                  <a
                    href={training.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn-primary btn-sm"
                  >
                    Abrir en Google Slides
                    <ExternalLink size={14} />
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Empty State */}
      {filteredManuals.length === 0 && searchQuery && (
        <div className="card p-12 text-center">
          <BookOpen size={48} className="mx-auto text-text-tertiary mb-4" />
          <h3 className="text-lg font-semibold text-text-primary mb-2">
            No se encontraron resultados
          </h3>
          <p className="text-text-secondary">
            No hay documentos que coincidan con "{searchQuery}"
          </p>
        </div>
      )}
    </div>
  );
};

export default TrainingPage;

